import { render, staticRenderFns } from "./StudentHistoryHeader.vue?vue&type=template&id=892b71c6&scoped=true&lang=pug&"
import script from "./StudentHistoryHeader.vue?vue&type=script&lang=ts&"
export * from "./StudentHistoryHeader.vue?vue&type=script&lang=ts&"
import style0 from "./StudentHistoryHeader.vue?vue&type=style&index=0&id=892b71c6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892b71c6",
  null
  
)

export default component.exports